import React, { createContext, useContext, useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import Loader from '../Common/Loader';
import { userWallet } from '../../api/auth.api';
// import { logout } from '../../Utilities/logout'; // TODO: NEED TO REMOV THIS
import { toastSuccess, toastError } from "../../Utilities/toast";

const ProfileDataContext = createContext()

const ProfileDataProvider = ({ children }) => {
     const [profileData, setProfileData] = useState(null)
     const [loading, setLoading] = useState(false)
     const [liteProfile, setLiteProfile] = useState()

     const fetchAccountProfile = async () => {
          try {
               const data = await userWallet();

               if (data?.success) {
                    setLiteProfile(data?.data)
                    localStorage.setItem("profile", JSON.stringify(data?.data))
               }

          } catch (error) {
               toastError(error?.response?.errors?.[0]?.msg)
          }
     };

     if (loading) return <Loader />
     return (
          <ProfileDataContext.Provider value={{ profileData, setProfileData, fetchAccountProfile, liteProfile }}>
               {children}
          </ProfileDataContext.Provider>
     )
}

export default ProfileDataProvider
export const useProfileDataContext = () => {

     return useContext(ProfileDataContext)
}